import { render, staticRenderFns } from "./MyAccountEdit.vue?vue&type=template&id=c508133c&scoped=true&"
import script from "./MyAccountEdit.vue?vue&type=script&lang=js&"
export * from "./MyAccountEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c508133c",
  null
  
)

export default component.exports